import { ApiClient } from '../api-client';

const CommunicationApi = ApiClient.service.communication;
/**
 *  UseCommunicationApi is a hook that returns a reusable axios instance with auth
 * @returns {AxiosInstance}
 */
const useCommunicationApi = () => {
  return CommunicationApi;
};

export { CommunicationApi, useCommunicationApi };
